<!--
 * @Author: hai.zhang
 * @LastEditors: hai.zhang
-->
<template>
  <div class="sy-boole banner">
    <component :is="newComponentName" v-on="$listeners" v-bind="{ ...$props }" :type="type" v-model='value'/>
  </div>
</template>
<script>
import radioBoole from './components/radio-boole.vue'
import checkboxBoole from './components/checkbox-boole.vue'
import readTextBoole from './components/read-text-boole.vue'
import { booleProps } from './index.js'

export default {
  name: 'boole',
  props: booleProps,
  model: {
    prop: 'value',
    event: 'change'
  },
  components: {
    radioBoole,
    checkboxBoole,
    readTextBoole
  },
  computed: {
    // 判断布尔组件样式
    newComponentName () {
      if (this.isPureText) {
        return 'read-text-boole'
      }
      if (this.uiComponent === 1 || !this.uiComponent) {
        return 'radioBoole'
      }
      return 'checkboxBoole'
    }
  }
}
</script>
<style scoped lang="scss">
.sy-boole {
  // overflow: hidden;
  ::v-deep .el-checkbox {
    /* white-space: pre-wrap !important; */
    vertical-align: middle;
  }
  
  ::v-deep .el-checkbox-group {
    line-height: 32px;
  }

  // .boole-small {
  //   // margin-top: 8px;
  //   height: 32px;
  //   line-height: 32px;
  // }

  .check-group {
    height: 32px;
    line-height: 32px;
    vertical-align: middle !important;
    ::v-deep .el-checkbox__input {
      display: inline-block;
      line-height: 20px;
      vertical-align: middle;
    }
  }
}
</style>
